import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-display text-2xl text-primary-600">迷妹漫画</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${isActive("/") ? "text-primary-600" : "text-foreground-600 hover:text-primary-500"}`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className={`text-sm font-medium whitespace-nowrap transition-colors flex items-center gap-1 ${location.pathname.startsWith("/category") ? "text-primary-600" : "text-foreground-600 hover:text-primary-500"}`}>
                分类 <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 px-1 shadow-sm min-w-[180px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-3 py-2 text-sm text-foreground-600 hover:text-primary-600 hover:bg-primary-50 rounded-md whitespace-nowrap"
                    >
                      <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${isActive("/about") ? "text-primary-600" : "text-foreground-600 hover:text-primary-500"}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-user-line text-primary-600 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-8 h-8 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <Link
            to="/"
            onClick={() => setMobileOpen(false)}
            className={`block py-2 text-sm font-medium ${isActive("/") ? "text-primary-600" : "text-foreground-600"}`}
          >
            首页
          </Link>
          <div className="py-2 text-sm font-medium text-foreground-500">分类</div>
          <div className="grid grid-cols-2 gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-1.5 px-2 py-1.5 text-sm text-foreground-600 rounded-md"
              >
                <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            onClick={() => setMobileOpen(false)}
            className={`block py-2 text-sm font-medium ${isActive("/about") ? "text-primary-600" : "text-foreground-600"}`}
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}